import Vue from 'vue';
import alice from '../../alice-api';

export default {
  namespaced: true,
  state: {
    npsFormData: {},
    npsFormWithFilterData: {},
    npsSummaryWithFilterData: {},
  },
  getters: {
    npsFormData: (state) => state.npsFormData,
    npsFormWithFilterData: (state) => state.npsFormWithFilterData,
    npsSummaryWithFilterData: (state) => state.npsSummaryWithFilterData,
  },
  actions: {
    // createNPSForm(context, params) {
    //   const { data } = params;
    //   return new Promise((resolve, reject) => {
    //     alice
    //       .createNPSForm(data)
    //       .then((response) => {
    //         resolve(response.data);
    //       })
    //       .catch((error) => {
    //         reject(error);
    //       });
    //   });
    // },
    getNPSForm(context) {
      return new Promise((resolve, reject) => {
        alice
          .getNPSForm()
          .then((response) => {
            const { data } = response.data;
            context.commit('setNPSFormData', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getNPSFormWithFilter(context, params) {
      const { searchBody } = params;
      return new Promise((resolve, reject) => {
        alice
          .getNPSFormWithFilter(searchBody)
          .then((response) => {
            const { data } = response.data;
            context.commit('setNPSFormWithFilterData', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getNPSSummaryWithFilter(context, params) {
      const { searchBody } = params;
      return new Promise((resolve, reject) => {
        alice
          .getNPSSummaryWithFilter(searchBody)
          .then((response) => {
            const { data } = response.data;
            context.commit('setNPSSummaryWithFilterData', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    exportNPSForm(context, params) {
      const { searchBody } = params;
      return new Promise((resolve, reject) => {
        alice
          .exportNpsForm(searchBody)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  mutations: {
    setNPSFormData(state, data) {
      Vue.set(state, 'npsFormData', data);
    },
    setNPSFormWithFilterData(state, data) {
      Vue.set(state, 'npsFormWithFilterData', data);
    },
    setNPSSummaryWithFilterData(state, data) {
      Vue.set(state, 'npsSummaryWithFilterData', data);
    },
  },
};
